import { LockOpen } from "lucide-react";

import { OPEN_CASH_REGISTERS_WARNING } from "./types";

type OpenCashRegistersBannerProps = {
  readonly codes: readonly number[];
};

export function OpenCashRegistersBanner({
  codes,
}: OpenCashRegistersBannerProps) {
  return (
    <div
      role="alert"
      className="w-full flex gap-3 rounded-md border border-red-300 bg-red-50 p-4"
    >
      <LockOpen className="h-5 w-5 text-red-600 shrink-0 mt-0.5" />
      <div className="flex flex-col gap-1 text-sm text-red-900">
        <p className="font-semibold">
          {codes.length === 1
            ? OPEN_CASH_REGISTERS_WARNING.singular
            : OPEN_CASH_REGISTERS_WARNING.plural}
        </p>
        <p>
          {codes.length === 1
            ? OPEN_CASH_REGISTERS_WARNING.codesLabelSingular
            : OPEN_CASH_REGISTERS_WARNING.codesLabelPlural}{" "}
          {codes.join(", ")}
        </p>
        <p className="text-red-800">
          {OPEN_CASH_REGISTERS_WARNING.instruction}
        </p>
      </div>
    </div>
  );
}
